/**
 * DEMO review data — placeholder content only, NOT real customer reviews.
 * Replace the entries below with real photos/comments once available; both
 * the right-column carousel and the bottom mini-review card read from this
 * single array so there is only one place to update.
 */
window.PfReviews = [
  {
    image: 'foto-carrusel-1.jpg',
    rating: 5,
    comment: 'Un souvenir adorable, on adore le résultat.',
    petName: 'Rémy',
    breed: 'Bouledogue français',
  },
  {
    image: 'foto-carrusel-2.jpg',
    rating: 5,
    comment: 'Ressemblance parfaite, livraison rapide.',
    petName: 'Lola',
    breed: 'Teckel',
  },
  {
    image: 'foto-carrusel-4.jpg',
    rating: 5,
    comment: 'La finition est vraiment soignée.',
    petName: 'Luna',
    breed: 'British Shorthair',
  },
  {
    image: 'foto-carrusel-5.jpg',
    rating: 5,
    comment: 'Exactement ce qu\'on espérait, merci !',
    petName: 'Loulou',
    breed: 'Beagle',
  },
  {
    image: 'foto-carrusel-8.jpg',
    rating: 5,
    comment: 'Un beau souvenir posé sur l\'étagère.',
    petName: 'Loulou',
    breed: 'Bengal',
  },
];
